// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"4323cd79","815":"a13362a4","989":"9b25f2a2"}[chunkId] + ".chunk.js";
};